export enum SkeletonAppearanceType {
  CIRCLE = 'circle',
  HEADLINE = 'headline',
  SUBLINE = 'subline',
  TEXT = 'text',
  TILE = 'tile',
}
